<template>
  <transition @enter="enter" @leave="leave">
    <div
      v-if="visible"
      ref="drawerDom"
      :class="$style['drawer-component']"
      @click.self="close"
    >
      <div ref="innerBox" :class="$style['inner-box']">
        <slot :close="close" />
      </div>
    </div>
  </transition>
</template>
<script>
import "@/assets/newCss/reset.scss";
import "@/assets/tailwendcss.css";
import "@/assets/uemo-icon-font/fonts/ueicon.css";
import "@/assets/newCss/var.scss";
import "@/assets/newCss/base.scss";

import { gsap } from '@/utils/gsap'
export default {
  props: ["visible"],
  methods: {
    close() {
      this.$emit("close");
    },
    enter(el, done) {
      gsap.timeline({
        onStart: function () {
          $(el).appendTo(document.body);
        },
        onComplete: done,
        defaults: { duration: 0.26 },
      })
        .from(el, { background: "rgba(0, 0, 0, 0)" })
        .from(this.$refs.innerBox, { opacity: 0, y: 20 }, 0);
    },
    leave(el, done) {
      gsap.timeline({
        onStart: function () {
          $(el).appendTo(document.body);
        },
        onComplete: done,
        defaults: { duration: 0.26 },
      })
        .to(el, { background: "rgba(0, 0, 0, 0)" })
        .to(this.$refs.innerBox, { opacity: 0, y: 20 }, 0);
    },
  },
  beforeUnmount() {
    if (this.$refs.drawerDom) {
      $(this.$refs.drawerDom).remove();
    }
  },
};
</script>
<style lang="scss" module>
@import '../../assets/uemo-scss/scss/abstracts/_functions.scss';

.drawer-component {
  position: fixed;
  z-index: calc(var(--g--layer--z-index--lv1) + 20);
  bottom: 0;
  left: 0;
box-shadow: none;
  width: 100vw;
  // height: 100vh;
  height: var(--g--full-height);
  background: rgba(0, 0, 0, 0.8);
  
  .inner-box {
    box-shadow: none;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/Drawer.vue